import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Modal } from 'services/modal';
import { Observable } from 'rxjs';

export class ModalBase {
    private dialog: MatDialog;
    private modal: Modal;

    constructor(dialog: MatDialog, modal: Modal) {
        Object.assign(this, { dialog, modal });
    }

    /* eslint-disable  @typescript-eslint/no-explicit-any */
    public open<D, R = any, C = any>(component: ComponentType<C>, data?: D, config?: MatDialogConfig<D>, delayClose?: boolean): Observable<R> {
        return this.modal.open(this.dialog, component, { ...config, data }, delayClose);
    }
    /* eslint-enable  @typescript-eslint/no-explicit-any */
}
